import { Inject, Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  language!: string;
  translations: Map<string, string> = new Map<string, string>();
  constructor(private http: HttpClient) {
  }
  changeTranslations(lang:string){
    this.language=lang;
    this.getTranslationsForLanguage(lang);
  }
  getTranslationsForLanguage(lang: string) {
    this.translations.clear;
    if(lang.length>2){
      lang = lang.substring(0, 2);
    }
    return firstValueFrom(this.http.get<any>(environment.API_BASE_URL + "/api/translation/" + lang)).then((data:any)=>{
      for(var field in data){
      this.translations.set(field,data[field]);
      }
    });
  }
  translate(key:string, ...args: any[]):string{
    if(this.translations.has(key)){
      let translation = this.translations.get(key)??"";
      // Replace placeholders {0}, {1}, {2}, etc. with provided arguments
      return translation.replace(/\{(\d+)\}/g, (match, index) => {
        return args[index] !== undefined ? args[index] : match;
      });
    }
    else {
      console.log("Missing translation:"+key);
      return key;
    }
  }
}
